import { ProFormGroup } from '@ant-design/pro-components'
import type React from 'react'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { mergeFieldProps } from '../utils/mergeFieldProps'

export type GroupFieldProps = React.ComponentProps<typeof ProFormGroup>

export function GroupField(props: GroupFieldProps) {
  const fieldCtx = useFieldContext<any>()
  const { title, children, className, ...rest } = props

  const editable = useEditableFieldMode<any>()

  const merged = mergeFieldProps({
    fieldCtx,
    editable,
    props: {
      ...props,
      label: title, // ProFormGroup uses title instead of label
    },
  })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormGroup
        {...rest}
        title={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {title}
          </EditableLabel>
        }
        {...merged.proFieldProps}
      >
        {children}
      </ProFormGroup>
    </EditableShell>
  )
}
